import fs from 'fs';

const cache = {};
function getMock(name) {
  if(!cache[name]) {
    cache[name] = `require('${require.resolve(`./mock/${name}`)}'`;
  }
  return cache[name];
}

function getVariableSource(variable) {
  if(variable.name === 'global') {
    return 'function() {return this;}';
  } else {
    return getMock(variable.name);
  }
}